import localforage from 'localforage';
import Request from '../utilities/Request.jsx';


export default class SiteUrlStorage {
	static once = false;
	static storage = null;

	static _setup() {
		if(this.storage) {
			return this.storage;
		}
		return this.storage = localforage.createInstance({
			storeName: 'siteUrl'
		});
	}

	static async store() {
		if(!this.once && typeof siteUrl !== 'undefined') {
			this.once = true;
			const storage = this._setup();
			storage.setItem('siteUrl', siteUrl);
		}
	}

	static async retrieve() {
		const storage = this._setup();
		const siteUrl = await storage.getItem('siteUrl');
		Request.siteUrl = siteUrl;
		return siteUrl;
	}
}